<div class="container">

  <div class="container text-center mt-5">
    <span style="color:var(--primary-color);" class="fs-2 fw-bolder">Fisioterapia <span class="fw-medium ">integral </span> </span>
  </div>

  <div class="container px-4 py-2" id="icon-grid">

    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 g-5 py-5 justify-content-center ">
      <div *ngFor=" let service of services" class="col d-flex align-items-center ">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">{{ service.nameEspecialidad }}</h3>
        </div>
      </div>

    </div>
  </div>

</div>
